





































import {Component, Prop, Vue} from 'vue-property-decorator'
import fairyLight1 from '@/assets/img/christmas/fairy_light_1.png'
import fairyLight2 from '@/assets/img/christmas/fairy_light_2.png'

@Component
export default class TwinkleEffect extends Vue {
  @Prop({type: String, default: 'top'}) position!: 'top' | 'bottom'

  currentImage = fairyLight2

  mounted() {
    setInterval(() => {
      this.currentImage =
        this.currentImage === fairyLight2 ? fairyLight1 : fairyLight2
    }, 500)
  }
}
